import { useNavigate } from "@tanstack/react-router";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { FaFacebook, FaInstagram, FaTwitter } from "react-icons/fa";

import { useGetUserMeta } from "@/api/queries";
import useDomainConfigAuth from "@/api/sanity/queries/getSiteConfigWithDomain";
import AuthPrimaryButton from "@/components/AuthPrimaryButton";
import BackButton from "@/components/BackButton";
import SmallButton from "@/components/SmallButton";
import Spacer from "@/components/Spacer";
// import AppState from "@/store/appstate";
import useAppStore from "@/store/appStateZustand";

function AddAccount6() {
  const { t } = useTranslation("onboarding");
  const navigate = useNavigate();
  // const twitterResult = AppState.useState(s => s.addAccount.twitter);
  const twitterResult = useAppStore(s => s.addAccount?.twitter);
  // const facebookResult = AppState.useState(s => s.addAccount.facebook);
  const facebookResult = useAppStore(s => s.addAccount?.facebook);
  // const instagramResult = AppState.useState(s => s.addAccount.instagram);
  const instagramResult = useAppStore(s => s.addAccount?.instagram);
  const userMeta = useGetUserMeta();
  const [pending, setPending] = useState(false);
  const { data: domainConfig } = useDomainConfigAuth();

  if (domainConfig.hide_socials) {
    navigate({ to: "/add-account-final" });
  }

  let title = t("onboarding:connect-social-header1");
  switch (userMeta?.data?.role) {
    case "Manager":
      title = t("onboarding:connect-social-header2");
      break;
    default:
      break;
  }
  return (
    <div className="container mx-auto">
      <div className="flex flex-col items-center justify-center p-4 text-center text-white min-h-screen-minus-footer">
        <h1 className="text-6xl">{title}</h1>
        <Spacer />

        <div className="flex flex-row flex-wrap justify-center gap-6">
          {!instagramResult && (
            <div className="flex flex-col items-center p-4 px-6 bg-white/80 rounded-lg shadow-lg text-ink-primary">
              <p className="mb-2 text-4xl">
                <FaInstagram />
              </p>
              <p>{t("onboarding:_instagram")}</p>
              <Spacer />
              <SmallButton onClick={() => navigate({ to: "/add-instagram" })}>
                {t("onboarding:add-account-button")}
              </SmallButton>
            </div>
          )}
          {!!instagramResult && (
            <div className="flex flex-col items-center p-4 px-6 bg-white/80 rounded-lg shadow-lg text-ink-primary">
              <p style={{ fontSize: "80px" }} className="mb-4">
                <FaInstagram />
              </p>
              <p className="mb-4 font-bold">{instagramResult}</p>
              <SmallButton onClick={() => navigate({ to: "/add-instagram" })}>
                {t("onboarding:edit-instagram")}
              </SmallButton>
            </div>
          )}
          {!facebookResult && (
            <div className="flex flex-col items-center p-4 px-6 bg-white/80 rounded-lg shadow-lg text-ink-primary">
              <p className="mb-2 text-4xl">
                <FaFacebook />
              </p>
              <p>{t("onboarding:_facebook")}</p>
              <Spacer />
              <SmallButton onClick={() => navigate({ to: "/add-facebook" })}>
                {t("onboarding:add-account-button")}
              </SmallButton>
            </div>
          )}
          {!!facebookResult && (
            <div className="flex flex-col items-center p-4 px-6 mb-4 bg-gray-300 rounded-lg shadow-lg text-ink-primary">
              <p style={{ fontSize: "80px" }} className="mb-4">
                <FaFacebook />
              </p>
              <p className="mb-4 font-bold">
                {facebookResult.replace("https://www.facebook.com/", "")}
              </p>
              <SmallButton onClick={() => navigate({ to: "/add-facebook" })}>
                {t("onboarding:edit-facebook")}
              </SmallButton>
            </div>
          )}

          {!twitterResult && (
            <div className="flex flex-col items-center p-4 px-6 bg-white/80 rounded-lg shadow-lg text-ink-primary">
              <p className="mb-2 text-4xl">
                <FaTwitter />
              </p>
              <p>{t("onboarding:_twitter")}</p>
              <Spacer />
              <SmallButton onClick={() => navigate({ to: "/add-twitter" })}>
                {t("onboarding:add-account-button")}
              </SmallButton>
            </div>
          )}
          {!!twitterResult && (
            <div className="flex flex-col items-center p-4 px-6 bg-white/80 rounded-lg shadow-lg text-ink-primary">
              <p style={{ fontSize: "80px" }} className="mb-4">
                <FaTwitter />
              </p>
              <p className="mb-4 font-bold">{twitterResult}</p>
              <SmallButton onClick={() => navigate({ to: "/add-twitter" })}>
                {t("onboarding:edit-twitter")}
              </SmallButton>
            </div>
          )}
          {/* {!!twitterResult
            && (
              <>
                <div className="flex flex-col items-center p-4 px-6 mb-4 ml-2 mr-2 bg-gray-300 rounded-lg shadow-lg text-ink-primary">
                  {JSON.parse(twitterResult).data.profile_image_url && JSON.parse(twitterResult).data.profile_image_url.length > 0
                     && (
                     <img
                       className="object-cover w-20 h-20 mb-4 rounded-full"
                       alt={JSON.parse(twitterResult).data.name}
                       src={JSON.parse(twitterResult).data.profile_image_url}
                     />
                     )}
                  {(!JSON.parse(twitterResult).data.profile_image_url)
                    && <div className="w-20 h-20 mb-4 bg-gray-300 rounded-full" />}
                  <p className="mb-4 font-bold">{JSON.parse(twitterResult).data.name}</p>
                  <SmallButton onClick={() => navigate({ to: '/add-twitter' })}>{t('onboarding:edit-twitter')}</SmallButton>
                </div>

              </>
            )} */}
        </div>

        <Spacer />

        <div className="flex flex-row w-full lg:w-1/3 justify-evenly">
          <BackButton onClick={() => navigate({ to: "/add-account-4" })}>
            {t("onboarding:back-button")}
          </BackButton>
          <AuthPrimaryButton
            pending={pending}
            onClick={() => {
              void navigate({ to: "/add-account-final" });
              setPending(true);
            }}
            arrow
          >
            {t("onboarding:next-step-button")}
          </AuthPrimaryButton>
        </div>
      </div>
    </div>
  );
}

export default AddAccount6;
